// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { miniMyAccountStyles } from "@west/App/Components/MiniMyAccount/MiniMyAccount";
import { color, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

miniMyAccountStyles.container = {
    css: css`
        ${xScreen("lte", "md")} {
            width: 100%;
            padding: 8px 16px;
        }
    `,
};

miniMyAccountStyles.gridContainer = {
    gap: 16,
};

miniMyAccountStyles.linkGridItem = {
    width: 12,
};

miniMyAccountStyles.titleContainer = {
    css: css`
        width: 100%;
        border-bottom: 1px solid ${color("common.border")};
        padding-bottom: 8px;
        margin-bottom: 16px;
    `,
};
miniMyAccountStyles.title = {
    variant: "h4",
    forwardAs: "p",
    ellipsis: true,
    css: css`
        margin-bottom: 0;
        letter-spacing: 0;
        line-height: 24px;
    `,
};

miniMyAccountStyles.link = {
    typographyProps: {
        size: 12,
    },
};
